import { useNavigate, useParams } from "react-router-dom";
import { Messages } from "primereact/messages";
import { useEffect, useRef, useState } from "react";
import { ServiceCard } from "../components/ServiceCard";
import {
    GetServiceErrors,
    GetSubServiceStatus
} from "../services/GetServiceStatus";
import { IServiceEvent } from "../types/IServiceEvent";
import { Spinner } from "@idwal/idwal-react-components";
import { IParentService } from "../types/IParentService";
import { IdwalServices } from "../config/services";
import { IService } from "../types/IService";
import { EventsTable } from "../components/EventsTable";

const SubServiceStatusPage = () => {
    const navigate = useNavigate();
    const { id, service } = useParams() as { id: string; service: string };

    const [events, setEvents] = useState<IServiceEvent[] | null>(null);
    const [errors, setErrors] = useState<IServiceEvent[] | null>(null);
    const [mainService, setMainService] = useState<IParentService | undefined>(
        undefined
    );
    const [subService, setSubService] = useState<IService | undefined>(
        undefined
    );

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const messages = useRef<any>(null);

    useEffect(() => {
        async function getData() {
            if (id && service) {
                const data = await GetSubServiceStatus(id, service);
                const eventErrors = GetServiceErrors(data).filter(
                    (e) => e.serviceKey === service
                );
                setEvents(data);
                setErrors(eventErrors);
                const parentService = IdwalServices.find(
                    (pService) => pService.id === id
                );
                setMainService(parentService);
                setSubService(
                    parentService?.services.find(
                        (_service) => _service.name === service
                    )
                );
            }
        }
        getData();
        const interval = setInterval(function () {
            getData();
        }, 60000);
        return () => clearInterval(interval);
    }, [id]);

    useEffect(() => {
        if (messages && messages.current) {
            messages.current.clear();
            if (errors && errors.length > 0) {
                messages.current.show([
                    {
                        severity: "error",
                        summary:
                            "This service has errors. Please see the issues and action accordingly.",
                        sticky: true
                    }
                ]);
            }
        }
    }, [errors]);

    return (
        <div className="flex flex-column py-4">
            {mainService && events && errors && subService ? (
                <>
                    <div
                        onClick={() => navigate("/service/" + mainService?.id)}
                        className="flex align-items-center cursor-pointer select-none link-hover"
                    >
                        <i
                            className="pi pi-arrow-circle-left pr-1"
                            style={{ fontSize: "1em" }}
                        ></i>
                        <small style={{ marginTop: 2 }}>
                            Back to parent service
                        </small>
                    </div>
                    <Messages className="mt-2" ref={messages} />
                    <h1 className="mt-3">{service}</h1>

                    <ServiceCard
                        parentService={mainService}
                        events={events}
                        errors={errors}
                        service={subService}
                    />

                    <EventsTable
                        id={id}
                        events={events.filter((event) => {
                            return event.service === service;
                        })}
                    />
                </>
            ) : (
                <div className="mt-5">
                    <Spinner width={50} height={50} />
                </div>
            )}
        </div>
    );
};

export default SubServiceStatusPage;
